<template>
  <bulk-action-modal @confirmed="save()" @closed="$emit('closed')">
    <template v-slot:title>Create Topics</template>

    <template v-slot:content>
      <div class="create-topics-modal-container">
        <div class="topic-count">
          <label>Topic Count <span class="optional">( max 30 )</span></label>
          <input v-model="topicCount" type="number" min=1 max=30 />
        </div>
        <div class="topic-type">
          <label>Topic Type</label>
          <select
            v-model="topicType"
            name="topic-type"
            class="topic-type-selection"
          >
            <option value="null">
              Select Topic Type
            </option>
            <option
              v-for="(topicType, index) in topicTypes"
              :key="index"
              :value="topicType"
            >
              {{ topicType }}
            </option>
          </select>
        </div>
        <div class="product-select">
          <label>Select Product</label>
          <hlt-multiselect
            v-if="availableApps"
            ref="multiselect1"
            v-model="app"
            class="pa-product-select"
            :options="availableApps"
            :multiple="false"
            :show-labels="false"
            track-by="id"
            label="internal_name"
            placeholder="Select a Product"
            :disabled="!canWriteProductAssociations"
          />
        </div>
      </div>
    </template>
  </bulk-action-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import railsRoutes from '@/store/rails-routes.js'
import axios from 'axios'
import ProductAssociation from '../shared/ProductAssociation.vue'
import BulkActionModal from '@/components/assets/shared/bulk_actions/BulkActionModal.vue'
import BulkActionsMixin from '@/mixins/bulk-actions.js'
import HLTMultiselect from '../../shared/VueMultiSelect.vue'

export default {
  components: {
    'hlt-multiselect': HLTMultiselect,
    ProductAssociation,
    BulkActionModal,
    HLTMultiselect
  },
  mixins: [BulkActionsMixin],
  data () {
    return {
      saving: false,
      topicCount: 1,
      assignTo: null,
      reviewer: null,
      app: null,
      topicType: null,
      topicTypes: [
        'Standard',
        'Reference',
        'Case Study',
        'Asset Tray'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'assetType',
      'currentUser',
      'cmsUsers',
      'apps'
    ]),
    availableApps () {
      var as = this.currentUser.apps
      var asIds = this.currentUser.apps.map(x => x.id)
      return as.concat(this.apps
        .filter(k => asIds.indexOf(k.id) === -1)
        .filter(l => l.internal_name !== undefined))
        .sort((a, b) => {
          return (a.internal_name > b.internal_name) - (a.internal_name < b.internal_name)
        })
    },
    canWriteProductAssociations () {
      if (this.$router.isRoute('topic')) {
        return this.currentUser.permissions.can_write_topics_product_associations
      } else {
        return false
      }
    },
  },
  methods: {
    findAsset () {
      return { product_associations: this.associations }
    },
    save () {
      if (!this.saving) {
        // Disable save button so it can't be pressed multiple times
        this.saving = true
        var url = railsRoutes.api_path({ type: this.assetType + 's', action: 'batch_create' })

        var params = {
          asset_count: this.topicCount,
          app_id: this.app?.id,
          type_variant: this.topicType,
          reviewer_id: this.reviewer?.id,
          assign_to_id: this.assignTo?.id
        }

        axios.post(url, params).then(response => {
          this.saving = false
          let name = this.assetType.charAt(0).toUpperCase() + this.assetType.slice(1)
          const msg = `${name} Creation Started...`
          this.$modal.hide('bulk-action-modal')
          this.$notify({ title: msg, type: 'success' })
        })
      }
    },
    clearModalData () {
      this.saving = false
      this.associations = []
    }
  }
}

</script>
<style lang="scss" scoped>
.create-topics-modal-container {
  margin: 0;
  padding: 20px;
  min-height: 500px;
  height: auto;
  overflow: scroll;

  font-weight: 400;
  .button {
    color: $white-2;
  }

  > label {
    font-weight: 700;
    margin-bottom: 8px;
    font-size: 18px;
  }
  select {
    color: $space-gray;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .topic-count, .topic-type {
    width: 50%;
  }
  .optional-container {
    font-size: 1rem;
    width: 50%;
    .optional {
      color: $space-gray !important;
    }
  }

}
</style>
